import { type Dayjs } from "dayjs";

export const getDateFirstMinute = (date: Dayjs) => {
  return date.startOf("day").minute(1);
};

export const getDateLastMinute = (date: Dayjs) => {
  return date.endOf("day").second(0).millisecond(0);
};
